exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sql-preview-container {\n    background-color: #F0F0F0;\n}\n.preview-body{\n    background-color: #fff;\n    margin: 24px 24px 0px;\n    padding: 24px;\n    height: 365px;\n    overflow-y: auto;\n}\n.btn-copy{\n    margin: 24px;\n    float: right;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/sql-preview-popup/sql-preview-popup.component.css
// module id = ../../../../../src/app/shared/lookup/sql-preview-popup/sql-preview-popup.component.css
// module chunks = main